import BlockOpener from "./block-opener";

/**
 * 
 */
class BlockOpenerManager {

	/**
	 * @type Array
	 */
	blockOpenerList = [];

	/**
	 * @type String
	 */
	blockOpenerSelector = '.block-opener';

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onViewportChange = this.onViewportChange.bind( this );
		document.addEventListener( 'WMUViewportChange', this.onViewportChange );
	}

	/**
	 * 
	 */
	clear()
	{
		this.blockOpenerList.forEach( ( blockOpener ) =>
		{
			blockOpener.clear();
		} );

		this.blockOpenerList = [];
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	setup( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document;
		}

		contextElement.querySelectorAll( this.blockOpenerSelector ).forEach( ( openerElement ) =>
		{
			if ( ! openerElement.wmuBlockOpener )
			{
				const opener = new BlockOpener( openerElement );
				opener.setup();
				this.blockOpenerList.push( opener );
			}
		} );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onViewportChange( event )
	{
		// this.clear();
		this.setup();
	}

}

export default BlockOpenerManager;